import env from '@/config/env';
import { errorGQLHandler } from '@/helpers/helpers';
import Planos from '@/graphql/tabela/queries/Planos.gql';
import { groupBy } from 'lodash';

const Types = {
  PLANOS: 'PLANOS',
  CLEAR: 'CLEAR',
};

const getPlanosWithArray = (plano) => {
  const { false: withoutSVA, true: withSVA } = groupBy(plano, 'plano.sva');
  const { mensal: withoutMonthly, anual: withoutYearly } = groupBy(withoutSVA, 'plano.frequencia');
  const { mensal: withMonthly, anual: withYearly } = groupBy(withSVA, 'plano.frequencia');

  return {
    sem: {
      mensal: withoutMonthly,
      anual: withoutYearly,
    },
    sva: {
      mensal: withMonthly,
      anual: withYearly,
    }
  }
}

const defaultPlanos = {
  pos: {
    sva: {
      mensal: [],
      anual: []
    },
    sem: {
      mensal: [],
      anual: []
    }
  },
  pre: {
    sva: {
      mensal: [],
      anual: []
    },
    sem: {
      mensal: [],
      anual: []
    }
  },
  controle: {
    sva: {
      mensal: [],
      anual: []
    },
    sem: {
      mensal: [],
      anual: []
    }
  },
}

export default {
  namespaced: true,
  state: {
    planos: defaultPlanos
  },
  getters: {
    planos: state => {
      return arr => state.planos[arr]
    }
  },
  mutations: {
    [Types.CLEAR](state) {
      state.planos = defaultPlanos
    },
    [Types.PLANOS](state, payload) {
      state.planos = payload.planos
    }
  },
  actions: {
    async getPlanos({ commit }, { tabela, modelo, renova }) {
      try {
        const query = await env.tabela.query({
          query: Planos,
          variables: {
            tabela,
            renova,
            modelo,
          },
          fetchPolicy: 'no-cache'
        });

        const { data } = query.data.response;

        /**
         * Portfólio:
         *  - 1: Pós
         *  - 2: Pré
         *  - 3: Controle
         */
        const { 1: pos, 2: pre, 3: controle } = groupBy(data, 'plano.tipo.id');

        const planos = {
          pos: getPlanosWithArray(pos),
          pre: getPlanosWithArray(pre),
          controle: getPlanosWithArray(controle)
        };

        commit(Types.PLANOS, { planos })

      } catch (e) {
        errorGQLHandler(e)
      }
    },
  }
}
